var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileComment24X24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.7605C20 7.02751 16.4186 4 12 4C7.58138 4 4 7.02265 4 10.7605C4.11283 12.3703 4.7615 13.893 5.83919 15.078C6.91689 16.2629 8.35938 17.0396 9.92917 17.2799V20L13.7748 17.3301C15.4012 17.1397 16.9118 16.3801 18.0476 15.1815C19.1834 13.9829 19.8737 12.4199 20 10.7605Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileComment24X24);
export default __webpack_public_path__ + "static/media/mobile-comment-24x24.3c1404df77d312b0539ead536980b192.svg";
export { ForwardRef as ReactComponent };